import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GuideData } from '../types/types';
import moment from "moment";

const ApprovalView = styled('div')(() => ({
  fontStyle: 'italic',
  marginTop: '10px',
  fontSize: '13px'
}));

export default function ApprovalComponent({ guide }: { guide: GuideData }) {
  const { t } = useTranslation('troubleshoot');

  return (
    guide.approvalDate && (
      <ApprovalView>
        {t('troubleshoot.general.latestApproval')}: {moment(guide.approvalDate).format('YYYY-MM-DD')}
      </ApprovalView>
    )
  );
}
